export default "__VITE_ASSET__MSVbBDiA__"